import { useParams } from 'react-router-dom'
import { style } from 'typestyle'

/* Core ========================================================================================= */
import { Box } from '../../__aeki__/components/box/box.component'
import { Button } from '../../__aeki__/components/button'
import { addSnippet } from '../../__aeki__/core/snippet-manager'

/* Components =================================================================================== */
import { Snippet, SnippetHead } from '../../__aeki__/modules/layouts/snippet'

export default addSnippet('ContentPreview', (props: any) => {
  const { row } = props
  const { baseId } = useParams<any>()

  const MAP: any = {
    'blog-posts': 'blog',
    'content-docs': 'docs',
  }

  return (
    <Snippet>
      <SnippetHead title={'Preview'}>
        <Button
          label={'Open'}
          baseline={'primary'}
          size="sm"
          square
          onClick={() => {
            window.open(`${process.env.REACT_APP_WEB_URL}/a/${MAP[baseId as any]}/${row.id}`)
          }}
        />
      </SnippetHead>
      <Box className={style({ zoom: 0.5 })}>
        {/* <BlogPostComponent post={{ payload: row }} /> */}
      </Box>
    </Snippet>
  )
})
